

import React from 'react';
import styled from 'styled-components';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, ReferenceLine, BarChart, Bar,
  ReferenceDot, Tooltip, CartesianGrid, Legend, Brush, ErrorBar, AreaChart, Area, Rectangle,
  Label, LabelList } from 'recharts';

const CustomBar = (props) => {
  const { label, fill } = props;
  let newFill = fill;
  if (label === 'L4' ) {
      newFill = 'blue';
  }
  return <Rectangle {...props} fill={newFill} className={`recharts-bar-rectangle ${label}`} />
};

const BarChartVsTarget = ({
  label,
  value,
  target,
  pastValues,
}) => {
  const periods = pastValues.length;
  const periodText = `L${periods}`;
  return (
    <BarChart
      width={200} height={250} data={[
        { label: periodText, value: (pastValues.reduce( ( p, c ) => p + c, 0 ) / periods).toFixed(1)},
        { label, value },
      ]}
      margin={{ top: 10, right: 30, bottom: 20, left: 0 }}
    >
      <CartesianGrid vertical={false} />
      <XAxis dataKey="label" label="" interval={0} />
      <YAxis domain={[0, target]} label="" />
      <Tooltip
        wrapperStyle={{
          borderColor: 'white',
          boxShadow: '2px 2px 3px 0px rgb(204, 204, 204)',
        }}
        contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
        labelStyle={{ fontWeight: 'bold', color: '#666666' }}
      />
      <Bar shape={CustomBar} dataKey="value" fill="green"  isAnimationActive={false} />
      {target && <ReferenceLine y={target} stroke="blue"></ReferenceLine>}
    </BarChart>
  );   
}

export default BarChartVsTarget;